var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetProfileEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#bfebff;}.cls-3{fill:#febe10;}.cls-4{fill:#fffbc5;}.cls-5{fill:#4d4d4d;}.cls-6{fill:#71c2ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.76,
    y: 0.25,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.76,
    y: 0.25,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "edit_profile_copy",
    "data-name": "edit profile copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546,106.19v442a50,50,0,0,1-50,50.07H54.78a50,50,0,0,1-50-50.07V241L189.37,56.12H496A50,50,0,0,1,546,106.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.68,404.86l-92.32-92.27,303.11-303a22.43,22.43,0,0,1,31.71,0L592.82,70.2a22.4,22.4,0,0,1,0,31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.68,372l-32,1.9h0l1.89-31.93-31.93,1.9-.29-.28,1.9-32-32,1.9-.15-.15,0,.16H198l.06.06-24,89.44a35.35,35.35,0,0,1,25.31,25.3l89.7-24-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.37,428.29l-34.58,9.25L174.06,403A35.35,35.35,0,0,1,199.37,428.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188,56.61V190.25a49.37,49.37,0,0,1-49.32,49.41H5.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileEdit);
export default __webpack_public_path__ + "static/media/pet_profile_edit.4cb191e895c836eb838dc4f55cb2de39.svg";
export { ForwardRef as ReactComponent };